import './App.css';
// import DisplayTodos from './components/DisplayTodos';
// import Todos from './components/Todos';
import ToDOMaster from './components/ToDOMaster';
// import ToDO from './components/ToDO';

function App() {
  return (
    <>
      <ToDOMaster />
      {/* <Todos /> */}
      {/* <DisplayTodos /> */}
    </>
  );
}

export default App;
